
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rebuild-hotline",
      function () {
        return require("private-next-pages/rebuild-hotline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rebuild-hotline"])
      });
    }
  